// ----------------------------------------------------------------------

export default function Paper() {
  return {
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },

      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: "0.5px solid #B6B6B6",
          borderRadius: 0,
          // padding: "20px",
        },
      },
    },
  };
}
